import { NumberPillBox, NumberText } from './styles';

const NumberPill = ({ id }) => {
  return (
    <NumberPillBox>
      <NumberText>{id}</NumberText>
    </NumberPillBox>
  );
};

export default NumberPill;
